import { React, useEffect } from "react";
import styles from "../ContactUs/ContactUs.module.css";
import Navbar from "../LandingPage/Navbar/Navbar";
import Footer2 from "../Footer2/Footer2";
import TopBar from "../EdofSectionNew2/TopBar/TopBar";
const ContactUs = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.charset = "utf-8";
    script.type = "text/javascript";

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "19647191",
          formId: "2c47a573-4534-439a-90ab-bd54aa96f656",
          region: "na1",
          target: "#hubspotForm",
          css: "",
        });
      }
    };

    document.body.appendChild(script);

    const style = document.createElement("style");
    style.innerHTML = `
    /* Form wrapper */
    #hubspotForm {
      max-width: 900px;
      width:100%;
      margin: 0 auto;
      padding: 0;
    }
              #hubspotForm .hs-form-required {
  color: red !important;
}

    /* Labels */
    #hubspotForm label {
      font-weight: 600;
      font-size: 15px;
      color: #00758d !important;
      display: block;
      margin-bottom: 6px;
       font-size: 17px;
        font-family: Open Sans;
    }

    /* Inputs */
    #hubspotForm input[type="text"],
    #hubspotForm input[type="email"],
    #hubspotForm input[type="tel"],
    #hubspotForm input[type="number"],
    #hubspotForm select,
    #hubspotForm textarea {
      width: 100% !important;
      padding: 12px 14px !important;
      font-size: 16px !important;
      border: none !important;
      border-radius: 6px !important;
      background: #f8fafc !important;
      margin-bottom: 20px !important;
      box-shadow: inset 0 0 0 1px #e0e0e0;
      transition: box-shadow 0.3s ease;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: normal;
      line-height: 22px;
    }

    /* Focus effect */
    #hubspotForm input:focus,
    #hubspotForm textarea:focus {
      outline: none !important;
      box-shadow: inset 0 0 0 2px #00a7e1 !important;
      background-color: white !important;
    }

    /* Submit Button */
    #hubspotForm input[type="submit"] {
      background-color: #00758d !important;
      color: white !important;
      font-weight: 600 !important;
      border: none !important;
      padding: 12px 28px !important;
      border-radius: 5px !important;
      font-size: 16px !important;
      cursor: pointer;
      transition: background-color 0.3s ease;
    }

    #hubspotForm input[type="submit"]:hover {
      background-color: #0084b4 !important;
    }

    /* Error message */
    .hs-error-msg {
      color: red !important;
      font-size: 13px !important;
      margin-top: 5px;
    }
  `;

    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div>
      <TopBar/>
      <Navbar />
      <div className={styles.ContactUsBody}>
        <div className={styles.LeftSection}>
          <img src="Images/contact-us.webp" alt="active couple gardening together" />
        </div>
        <div className={styles.RightSection}>
          <h1 className={styles.Title}>How can we help?</h1>
          <div className={styles.desc}>
            <p>
              At Bruno Vision Care, we’re here to support you. Whether you have
              questions, need assistance, or would like updates on our upcoming
              product launches, our team is ready to help.
            </p>
            <p>
              {" "}
              Please fill out the form or email us directly at{" "}
              <a
                href="https://mail.google.com/mail/u/0/?view=cm&to=customercare@brunovisioncare.com"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.customercarelink}
              >
                customercare@brunovisioncare.com.
              </a>
              <span> We look forward to hearing from you. </span>
            </p>
          </div>
        </div>
      </div>
      <div className={styles.Hubspot}>
        <div className={styles.bottomSection}>
          <div id="hubspotForm"></div>
        </div>
      </div>

      <Footer2 />
    </div>
  );
};

export default ContactUs;
